import React from 'react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { FormattedMessage } from 'react-intl';
import { AppMenuItemProps } from '../../AppMenuItemProps';

export const AboutMenuItem = ({
  classes,
  onClick
}: AppMenuItemProps): JSX.Element => {
  return (
    <MenuItem
      onClick={onClick}
      data-testid="about-menu"
      className={classes.menuItem}
    >
      <ListItemIcon className={classes.icon}>
        <InfoIcon />
      </ListItemIcon>
      <ListItemText>
        <FormattedMessage id="appMenu.about" />
      </ListItemText>
    </MenuItem>
  );
};
